/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { InspectionReportContext } from 'stores/InspectionReportStore'
import { Modal, Card, FlexView, Icon, Button, LoadingOverlay } from 'components/common'
import { RadioGroup } from 'components/form'


const WorkflowModal = ({ isOpen, onOutsideClick }) => {
  const { t } = useTranslation()
  const { executeWorkflowStep, reportToWorkflow } = useContext(InspectionReportContext)
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState('')
  const [currentStep, setCurrentStep] = useState({})
  
  const [stepOptions, setStepOptions] = useState([])

  useEffect(() => {
    if (reportToWorkflow) {
      let disabled = false
      const step = reportToWorkflow.next_workflow_status === 'to-sgro-send' ? (reportToWorkflow.workflow_status === 'tpi-approved' || reportToWorkflow.workflow_status === 'tpi-rejected') ? 'to-sgro-send-tpi' : 'to-sgro-send-customer' : reportToWorkflow.next_workflow_status
      setCurrentStep(step)
      setStep(extractStep(step))
      stepOptions.map((x) => {
        x.disabled = disabled
        if (x.value === step) {
          disabled = true
        }
        return x
      })  
    }   
  }, [reportToWorkflow]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (reportToWorkflow) {
      const stepFunctions = [
        {value: 'to-load-sgro', label: t('inspectionReport.to-load-sgro')}, 
        {value: 'to-s3-upload', label: t('inspectionReport.to-s3-upload')}    
      ]
  
      // Se status for Z3 signifca que o laudo não precisa ser aprovado pelo TPI.
      if (reportToWorkflow.report_status !== 'Z3') {
        stepFunctions.push({value: 'to-tpi-send-email', label: t('inspectionReport.to-tpi-send-email')})
        stepFunctions.push({value: 'to-tpi-approval', label: t('inspectionReport.to-tpi-approval')})
        stepFunctions.push({value: 'to-sgro-send-tpi', label: t('inspectionReport.to-sgro-send') + ' ' + t('inspectionReport.inspector')})  
      }
      
      stepFunctions.push({value: 'to-customer-send-email', label: t('inspectionReport.to-customer-send-email')})
      stepFunctions.push({value: 'to-customer-approval', label: t('inspectionReport.to-customer-approval')})
      stepFunctions.push({value: 'to-sgro-send-customer', label: t('inspectionReport.to-sgro-send') + ' ' + t('inspectionReport.customer')})
      stepFunctions.push({value: 'to-finish', label: t('inspectionReport.to-finish')})
  
      setStepOptions(stepFunctions)  
    }
  }, [t, reportToWorkflow])

  
  const extractStep = (step) => {
    const status = step === 'to-load-sgro' ? 'started' : 
      step === 'to-s3-upload' ? 'sgro-loaded' :
        step === 'to-tpi-send-email' ? 's3-uploaded' : 
          step === 'to-tpi-approval' ? 'tpi-email-sent' : 
            step === 'to-customer-approval' ? 'customer-email-sent' : 
              step === 'to-sgro-send-tpi' ? reportToWorkflow.tpi_approval_status :  
                step === 'to-sgro-send-customer' ? reportToWorkflow.customer_approval_status :  
                  'to-finish' 
      const nextStatus = (step === 'to-sgro-send-tpi' || step === 'to-sgro-send-customer') ? 'to-sgro-send' : step       
      return {status: status, nextStatus: nextStatus}
  }
  
  const onProcessClick = () => {
    setLoading(true)
    // console.debug(step)
    // setLoading(false)
    executeWorkflowStep(step).catch(e => {
      console.debug(e)
    }).finally(() => {
      setLoading(false)
      onOutsideClick()
    })      
  }

  const handleOptions = (event) => {
    setCurrentStep(event)
    setStep(extractStep(event))
  }  

  return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
    <Card padding="16px" maxWidth="500px" width="80vw" height="400px">
      <FlexView fontSize="subtitle" fontWeight="bold" flexDirection="row" justifyContent="space-between" alignItems="center" alignSelf="stretch">
        <span>{t('inspectionReport.workflow')}</span>
        <Icon name="cross" color="error" width="24px" height="24px" onClick={onOutsideClick} />
      </FlexView>

      <RadioGroup name="stepOptions" options={stepOptions} value={currentStep} onChange={handleOptions} ></RadioGroup>
      <FlexView flexDirection="row" justifyContent="flex-end" alignItems="center" alignSelf="stretch">

        {/* {reportToWorkflow && reportToWorkflow.workflow_fail_message ?
          <FlexView color="error" flexDirection="row" justifyContent="flex-start" alignItems="center" alignSelf="stretch">
            <Icon name="warning" color="error" margin="5px" width="18px" height="18px" title={t('inspectionReport.'+reportToWorkflow.workflow_fail_message)}></Icon>  
            <span style={{marginRight: '5px'}}>{t('inspectionReport.'+reportToWorkflow.workflow_fail_message)}</span>
          </FlexView>
        : null}        
         */}
        <Button margin="0px 0px 8px" color="white" backgroundColor="secondary" height="39px" onClick={onProcessClick}>{t('inspectionReport.execute_step')}</Button>
      </FlexView>
    </Card>
    <LoadingOverlay visible={loading} />
  </Modal>
}

export default WorkflowModal